import { render, staticRenderFns } from "./DeleteChargebackDialog.vue?vue&type=template&id=3fe83abe&"
import script from "./DeleteChargebackDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteChargebackDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports